import { Icons, Logos } from '@assets';
import { IAcl, INavMenuItem } from '@types';
import { isAllow } from '@utils/functions';
import React from 'react';

const { HeaderIcons } = Icons;

export const rkeeper = (rules: IAcl | undefined): INavMenuItem[] => [
    {
        name: 'Продажи ',
        desc: 'Продажи',
        icon: <img src={HeaderIcons.IconHeaderRkeeper} alt="Proga.pro logo" />,
        to: '/rkeeper/revenue',
        text: 'rkeeper_revenue',
        navKey: 'rkeeper.revenue',
        isAllow: isAllow(rules, 'rkeeper.viruchka'),
        subs: [
            {
                name: 'Выручка ',
                to: '/rkeeper/revenue',
                text: 'rkeeper_revenue',
                navKey: 'rkeeper.revenue',
                isAllow: isAllow(rules, 'rkeeper.viruchka'),
            },
            {
                name: 'Динамика ',
                to: '/rkeeper/dynamic',
                text: 'rkeeper_dynamic',
                navKey: 'rkeeper.dynamic',
                isAllow: isAllow(rules, 'rkeeper.dynamic'),
            },
        ],
    },
    {
        name: 'Товары ',
        desc: 'Товары ',
        icon: <img src={HeaderIcons.IconHeaderRkeeper} alt="Proga.pro logo" />,
        to: '/rkeeper/menu',
        text: 'rkeeper_menu',
        navKey: 'rkeeper.menu',
        isAllow: isAllow(rules, 'rkeeper.menu'),
        subs: [
            {
                name: 'Меню ',
                to: '/rkeeper/menu',
                text: 'rkeeper_menu',
                navKey: 'rkeeper.menu',
                isAllow: isAllow(rules, 'rkeeper.menu'),
            },
            {
                name: 'ТОП-позиции ',
                to: '/rkeeper/toppositions',
                text: 'rkeeper_toppositions',
                navKey: 'rkeeper.toppositions',
                isAllow: isAllow(rules, 'rkeeper.toppositions'),
            },
            {
                name: 'СТОП-позиции ',
                to: '/rkeeper/stoppositions',
                text: 'rkeeper_stoppositions',
                navKey: 'rkeeper.stoppositions',
                isAllow: isAllow(rules, 'rkeeper.stoppositions'),
            },
        ],
    },
    {
        name: 'Отчеты',
        desc: 'Отчеты',
        icon: <img src={HeaderIcons.IconHeaderRkeeper} alt="Proga.pro logo" />,
        to: '/rkeeper/reports_days',
        text: 'rkeeper_reports_days',
        navKey: 'rkeeper.report.days',
        isAllow: isAllow(rules, 'rkeeper.report.days'),
        subs: [
            {
                name: 'Отчеты по дням',
                to: '/rkeeper/reports_days',
                text: 'rkeeper_reports_days',
                navKey: 'rkeeper.report.days',
                isAllow: isAllow(rules, 'rkeeper.report.days'),
            },
            {
                name: 'Отчеты по ресторанам',
                to: '/rkeeper/reports_like4like',
                text: 'rkeeper_reports.like4like',
                navKey: 'rkeeper.report.like4like',
                isAllow: isAllow(rules, 'rkeeper.report.like4like'),
            },
            {
                name: 'АВС-анализ',
                to: '/rkeeper/reports_abc',
                text: 'rkeeper_reports.abc',
                navKey: 'rkeeper.report.abc',
                isAllow: isAllow(rules, 'rkeeper.report.abc'),
            },
        ],
    },
    {
        name: 'Склад ',
        desc: 'Склад ',
        icon: <img src={HeaderIcons.IconHeaderRkeeper} alt="Proga.pro logo" />,
        to: '/rkeeper/menu',
        text: 'rkeeper_menu',
        navKey: 'rkeeper.store',
        isAllow: isAllow(rules, 'rkeeper.store'),
        subs: [
            {
                name: 'Остатки ',
                to: '/rkeeper/ostatki',
                text: 'rkeeper_ostatki',
                navKey: 'rkeeper.store.ostatki',
                isAllow: isAllow(rules, 'rkeeper.store.ostatki'),
            },
        ],
    },
];

export default rkeeper;
